import { when } from '@microsoft/fast-element';
import { html } from '@microsoft/fast-element';
import { classNames } from '@microsoft/fast-web-utilities';
export const foundationConnectionIndicatorTemplate = html `
  <div class=${(x) => classNames(['light', true], [x.colour, true])}></div>
  ${when((x) => x.showLabel, html `
      <div class="label">${(x) => x.label}</div>
    `)}
`;
